import { render, staticRenderFns } from "./ObserverSettings.vue?vue&type=template&id=42e4e2cc&scoped=true&"
import script from "./ObserverSettings.vue?vue&type=script&lang=js&"
export * from "./ObserverSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e4e2cc",
  null
  
)

export default component.exports